exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".master-data{margin-top:70px;padding-top:20px}.master-tab-content{padding:20px}.color-code-heading{font-size:18px;margin:0;width:100%;text-align:left;padding:8px 0;border-bottom:dashed 1px #cecece}.button-box .btn{margin:10px}\n", ""]);

